import { AuthResources, RenderSvg } from 'components';
import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';

const TopMenuElementComp = (): ReactElement => {
  return (
    <>
      <div className="topMenuElement">
        <>
          <NavLink to="/panel" className="topMenuElementItem">
            <div className="beforeAccent">
              <svg
                width="10"
                height="80"
                viewBox="0"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0 80 H 11 V 70 C 10 75.5 5.5 80 0 80 H 0 V 80 Z"
                  fill="#fff"
                />
              </svg>
            </div>
            <div className="topMenuElementItemBox">
              <div className="topMenuElementItemAccent" />
              <span className="topMenuElementItemSpan">
                <svg
                  width="32"
                  height="26"
                  viewBox="0 0 32 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.0764 16.944C28.5577 16.944 28.1373 16.5234 28.1373 16.0047C28.1373 15.4858 28.5578 15.0653 29.0764 15.0653L31.9993 15.0654C31.7918 11.4478 30.3876 8.05682 27.9774 5.35192L25.9104 7.41936C25.7271 7.60283 25.4867 7.69451 25.2465 7.69451C25.0061 7.69451 24.7657 7.60283 24.5824 7.41936C24.2158 7.05242 24.2158 6.45776 24.5825 6.09072L26.6493 4.02328C23.9454 1.61227 20.5555 0.207719 16.9391 0V2.92395C16.9391 3.44271 16.5187 3.86328 16 3.86328C15.4815 3.86328 15.061 3.44271 15.061 2.92395V0C11.4447 0.207719 8.05482 1.61227 5.35086 4.02348L7.41768 6.09082C7.78449 6.45766 7.78449 7.05242 7.41768 7.41936C7.23428 7.60283 6.99401 7.69461 6.75364 7.69461C6.51338 7.69461 6.27301 7.60293 6.0897 7.41936L4.02298 5.35202C1.6126 8.05682 0.208536 11.4478 0.000986428 15.0654L2.92373 15.0653C3.44231 15.0653 3.86283 15.4858 3.86283 16.0047C3.86283 16.5234 3.44241 16.9441 2.92373 16.9441L0 16.9442C0.180448 20.0994 1.26974 23.0833 3.17809 25.6248C3.35548 25.861 3.6336 26 3.92886 26H28.0711C28.3665 26 28.6446 25.861 28.822 25.6248C30.7303 23.0832 31.8195 20.0994 32 16.9442L29.0764 16.944ZM21.8869 11.4443L19.3813 13.9509C19.7462 14.55 19.9567 15.2532 19.9567 16.0046C19.9567 18.1871 18.1817 19.9627 16 19.9627C13.8183 19.9627 12.0434 18.1871 12.0434 16.0046C12.0434 13.8222 13.8184 12.0467 16 12.0467C16.7513 12.0467 17.4542 12.2573 18.0532 12.6224L20.5589 10.1158C20.9256 9.74894 21.5202 9.74894 21.887 10.1158C22.2536 10.4826 22.2536 11.0775 21.8869 11.4443Z"
                    fill="#93B7E1"
                  />
                </svg>
                PANEL UCZESTNIKA
              </span>
            </div>
            <div className="afterAccent">
              <svg
                width="10"
                height="80"
                viewBox="0"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 0 70 H 0 V 80 H 10 C 4.4772 80 0 75.5229 0 70 Z"
                  fill="#fff"
                />
              </svg>
            </div>
          </NavLink>
          <AuthResources requiredRoles={['manager']}>
            <NavLink to="/kierownik" className="topMenuElementItem">
              <div className="beforeAccent">
                <svg
                  width="10"
                  height="80"
                  viewBox="0"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 80 H 11 V 70 C 10 75.5 5.5 80 0 80 H 0 V 80 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="topMenuElementItemBox">
                <div className="topMenuElementItemAccent" />
                <span className="topMenuElementItemSpan">
                  <RenderSvg nameSvg="manager" />
                  PANEL KIEROWNIKA
                </span>
              </div>
              <div className="afterAccent">
                <svg
                  width="10"
                  height="80"
                  viewBox="0"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 70 H 0 V 80 H 10 C 4.4772 80 0 75.5229 0 70 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
          </AuthResources>
          <AuthResources
            requiredRoles={[
              'training_department',
              'hr_bp',
              'slt_department',
              'admin_phr',
            ]}
          >
            <NavLink to="/administracja" className="topMenuElementItem">
              <div className="beforeAccent">
                <svg
                  width="10"
                  height="80"
                  viewBox="0"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 80 H 11 V 70 C 10 75.5 5.5 80 0 80 H 0 V 80 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="topMenuElementItemBox">
                <div className="topMenuElementItemAccent" />
                <span className="topMenuElementItemSpan">
                  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.7057 12.1404C16.0287 12.1404 18.7225 9.42267 18.7225 6.07019C18.7225 2.71772 16.0287 0 12.7057 0C9.38263 0 6.68879 2.71772 6.68879 6.07019C6.68879 9.42267 9.38263 12.1404 12.7057 12.1404ZM14.4806 29.8652C14.1492 29.5345 13.9329 29.1044 13.8642 28.6393C13.7955 28.1742 13.8781 27.6991 14.0995 27.2853L14.631 26.2736L13.5379 25.9398C13.0922 25.799 12.7042 25.5154 12.4327 25.132C12.1612 24.7486 12.0211 24.2862 12.0337 23.8152V21.7412C12.0329 21.2723 12.1816 20.8155 12.4579 20.4384C12.7342 20.0612 13.1234 19.7838 13.568 19.647L14.6611 19.3132L14.1396 18.3015C13.9247 17.8933 13.8429 17.4272 13.9059 16.9694C13.9689 16.5116 14.1736 16.0856 14.4906 15.752C13.7191 15.6499 12.9422 15.5959 12.1641 15.5901C9.86598 15.5355 7.58423 15.9932 5.4816 16.9306C3.37898 17.8679 1.50728 19.2618 0 21.0128V28.8535C0 29.1218 0.105653 29.3791 0.293716 29.5689C0.48178 29.7586 0.736849 29.8652 1.00281 29.8652H14.4806ZM29.7835 20.7966L31.7891 21.4032C31.8521 21.4399 31.9041 21.4931 31.9394 21.5572C31.9748 21.6213 31.9921 21.6939 31.9897 21.7673V23.8603C31.9854 23.94 31.9572 24.0165 31.9088 24.0797C31.8605 24.1429 31.7943 24.1898 31.7189 24.2142L29.7133 24.831C29.5732 25.3156 29.3816 25.7834 29.1417 26.2264L30.1445 28.1273C30.182 28.1985 30.1964 28.2797 30.1856 28.3596C30.1748 28.4394 30.1394 28.5138 30.0843 28.5722L28.6202 30.0384C28.5623 30.0939 28.4885 30.1296 28.4093 30.1405C28.3301 30.1514 28.2496 30.1369 28.179 30.0991L26.2837 29.0879C25.8452 29.3316 25.381 29.5249 24.8998 29.6643L24.2981 31.7371C24.2735 31.8119 24.2265 31.8773 24.1637 31.9244C24.101 31.9714 24.0253 31.9978 23.9471 32H21.8914C21.8115 31.9999 21.7336 31.9744 21.6688 31.9273C21.604 31.8801 21.5556 31.8136 21.5304 31.7371L20.9287 29.6643C20.4417 29.5231 19.971 29.3299 19.5247 29.0879L17.6495 30.0991C17.5789 30.1369 17.4983 30.1514 17.4192 30.1405C17.34 30.1296 17.2662 30.0939 17.2083 30.0384L15.7141 28.5722C15.656 28.5158 15.6178 28.4419 15.6051 28.3616C15.5924 28.2814 15.606 28.1991 15.6439 28.1273L16.6467 26.2062C16.397 25.7536 16.1953 25.2757 16.045 24.7805L14.0394 24.1637C13.9635 24.1415 13.8969 24.095 13.8498 24.031C13.8027 23.9671 13.7777 23.8894 13.7786 23.8098V21.7369C13.7777 21.6573 13.8027 21.5796 13.8498 21.5156C13.8969 21.4517 13.9635 21.4051 14.0394 21.383L16.045 20.7662C16.2096 20.2618 16.4282 19.777 16.6968 19.3203L15.694 17.48C15.6562 17.4082 15.6426 17.326 15.6552 17.2457C15.6679 17.1654 15.7062 17.0915 15.7642 17.0351L17.2383 15.5791C17.2963 15.5236 17.3701 15.4879 17.4492 15.477C17.5284 15.4661 17.609 15.4806 17.6796 15.5184L19.4947 16.5295C19.9543 16.2683 20.4422 16.0614 20.9487 15.9127L21.5504 13.8905C21.5751 13.8156 21.622 13.7502 21.6848 13.7032C21.7476 13.6562 21.8232 13.6298 21.9014 13.6276H23.9873C24.0659 13.627 24.1429 13.6509 24.2075 13.6962C24.2722 13.7414 24.3213 13.8058 24.3483 13.8803L24.96 15.9026C25.4569 16.0559 25.9373 16.2592 26.394 16.5093L28.2492 15.4982C28.3196 15.464 28.3987 15.4524 28.4759 15.4651C28.553 15.4777 28.6244 15.514 28.6804 15.569L30.1345 17.0452C30.1932 17.099 30.2321 17.1713 30.2449 17.2503C30.2576 17.3292 30.2434 17.4102 30.2047 17.48L29.2019 19.3607C29.4494 19.8154 29.6445 20.2972 29.7835 20.7966ZM21.0708 25.6116C21.6229 25.9815 22.2714 26.1778 22.9343 26.1758C23.8209 26.1732 24.6702 25.8162 25.2962 25.1831C25.9222 24.55 26.2737 23.6926 26.2737 22.7986C26.2737 22.1302 26.077 21.4769 25.7085 20.9213C25.34 20.3657 24.8163 19.9328 24.2037 19.6775C23.5911 19.4222 22.9171 19.3559 22.2671 19.4871C21.6172 19.6182 21.0204 19.9408 20.5523 20.4142C20.0843 20.8875 19.7661 21.4902 19.638 22.146C19.5099 22.8018 19.5777 23.4811 19.8327 24.098C20.0878 24.715 20.5186 25.2417 21.0708 25.6116Z"
                    />
                  </svg>
                  PANEL ADMINISTRACYJNY
                </span>
              </div>
              <div className="afterAccent">
                <svg
                  width="10"
                  height="80"
                  viewBox="0"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 70 H 0 V 80 H 10 C 4.4772 80 0 75.5229 0 70 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
          </AuthResources>
          <AuthResources requiredRoles={['training_department']}>
            <NavLink to="/ustawienia" className="topMenuElementItem">
              <div className="beforeAccent">
                <svg
                  width="10"
                  height="80"
                  viewBox="0"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 80 H 11 V 70 C 10 75.5 5.5 80 0 80 H 0 V 80 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
              <div className="topMenuElementItemBox">
                <div className="topMenuElementItemAccent" />
                <span className="topMenuElementItemSpan">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.0421 21.4436C21.1163 20.6605 21.0939 19.8802 20.9811 19.1185L22.7349 18.3336C22.5692 17.4805 22.3087 16.6391 21.9474 15.8247C21.5862 15.011 21.1376 14.2538 20.6176 13.559L18.8627 14.3433C18.3744 13.7502 17.8118 13.2119 17.1826 12.7429L17.8705 10.9433C17.1521 10.4582 16.3756 10.0481 15.5467 9.72874C14.7214 9.41052 13.8735 9.19047 13.0113 9.06861L12.3228 10.87C11.5429 10.7955 10.7658 10.818 10.0071 10.9312L9.23004 9.17892C7.49412 9.52141 5.87209 10.2607 4.47956 11.317L5.25146 13.0577C4.6596 13.548 4.12352 14.1135 3.65647 14.7447L1.86878 14.0563C1.38103 14.7759 0.972067 15.5562 0.653413 16.3878C0.337635 17.2195 0.121365 18.0731 0 18.9331L1.79228 19.6238C1.71809 20.407 1.74052 21.1872 1.85325 21.949L0.0995075 22.7333C0.265162 23.5869 0.525722 24.4278 0.886939 25.2422C1.24873 26.0565 1.6968 26.8131 2.21735 27.5079L3.9711 26.7236C4.45943 27.3173 5.02196 27.8555 5.65179 28.3245L4.96387 30.1253C5.68228 30.611 6.45878 31.0205 7.28763 31.3399C8.11302 31.6581 8.96085 31.8781 9.82305 32L10.5116 30.1986C11.2915 30.2726 12.0686 30.25 12.8273 30.1368L13.6043 31.8885C15.3403 31.546 16.9634 30.8068 18.3554 29.7505L17.5829 28.0097C18.1742 27.5194 18.7109 26.9546 19.1779 26.3227L20.9644 27.0112C21.4522 26.2916 21.8612 25.5113 22.1798 24.6802C22.4979 23.8485 22.7136 22.9944 22.835 22.1338L21.0421 21.4436ZM16.2778 22.4064C15.2477 25.1024 12.2365 26.4481 9.55099 25.4137C6.86889 24.3799 5.52698 21.357 6.55656 18.6616C7.58673 15.9662 10.5978 14.6205 13.2817 15.6538C15.9661 16.6876 17.3074 19.7116 16.2778 22.4064Z"
                      fill="#93B7E1"
                    />
                    <path
                      d="M30.7524 7.09282C30.7524 6.74398 30.7168 6.40265 30.6558 6.07114L32 5.29146C31.6744 4.04858 31.0279 2.93566 30.1439 2.05663L28.7962 2.83805C28.282 2.39565 27.6861 2.04913 27.0344 1.81811V0.257007C26.4408 0.0935621 25.819 0 25.1754 0C24.5318 0 23.9106 0.0947172 23.3164 0.257007V1.81869C22.6647 2.0497 22.0694 2.39681 21.5546 2.83863L20.2064 2.05721C19.3234 2.93623 18.6764 4.04916 18.3502 5.29204L19.695 6.07172C19.634 6.40381 19.5978 6.74398 19.5978 7.0934C19.5978 7.44281 19.634 7.78356 19.695 8.11507L18.3502 8.89476C18.6764 10.1376 19.3234 11.2511 20.2064 12.1296L21.554 11.3482C22.0688 11.7906 22.6641 12.1371 23.3158 12.3681V13.9298C23.91 14.0927 24.5312 14.1868 25.1748 14.1868C25.8185 14.1868 26.4408 14.0921 27.0338 13.9298V12.3681C27.6855 12.1371 28.2814 11.79 28.7956 11.3482L30.1433 12.1296C31.0274 11.2506 31.6739 10.1376 31.9994 8.89476L30.6552 8.11507C30.7168 7.78241 30.7524 7.44223 30.7524 7.09282ZM25.176 9.70678C23.738 9.70678 22.5721 8.53668 22.5721 7.0934C22.5721 5.65011 23.738 4.47943 25.176 4.47943C26.6122 4.47943 27.7781 5.64954 27.7781 7.09282C27.7781 8.5361 26.6122 9.70678 25.176 9.70678Z"
                      fill="#93B7E1"
                    />
                  </svg>
                  PANEL USTAWIEŃ
                </span>
              </div>
              <div className="afterAccent">
                <svg
                  width="10"
                  height="80"
                  viewBox="0"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M 0 70 H 0 V 80 H 10 C 4.4772 80 0 75.5229 0 70 Z"
                    fill="#fff"
                  />
                </svg>
              </div>
            </NavLink>
          </AuthResources>
        </>
      </div>
    </>
  );
};

export default TopMenuElementComp;
